import Converter from './components/Converter/Converter'

function App() {
  return (
    <div className="App">
      <Converter />
    </div>
  )
}

export default App
